<template>
  <div class="adm_main" style="overflow:hidden;"
    v-if="$parent.currentUser.adm_acc">
    <h2> Configure the Top-level Landing Page </h2>
    
    <b-row style="margin-top: 1rem">
      <b-col>
        Your landing page is at the URL:
      </b-col>
    </b-row>
    <b-row style="">
      <b-col>
       {{ getLandingURL() }}
      </b-col>
    </b-row>
    <b-row style="">
      <b-col>    
        <div class="btn btn-primary" v-if="$parent.currentUser.adm_acc">
           <a :href="getLandingURL()"
              target="_blank"
              style="color:white"
              variant="link">
              Your Landing Page
           </a>
        </div>
      </b-col>
    </b-row>
    
    <b-row style="margin-top: 1rem">
     <b-col>
      <b-form @submit.prevent="">
        <b-form-group label="Banner Primary and Secondary Text">
          <b-form-input
           type="text"
           v-model.trim="land.bnmsg"
           placeholder="Title / Primary Message"
          ></b-form-input>
          <b-form-input
           type="text"
           v-model.trim="land.bnsmsg"
           placeholder="Secondary Message"
          ></b-form-input>
        </b-form-group>
      </b-form>
     </b-col>
    </b-row>

    <b-row style="margin-top: 1rem">
     <b-col>
      <b-form @submit.prevent="">
        <b-form-group label="Background Image (Paste URL or Select a file)">
          <b-form-input
           type="text"
           v-model.trim="land.bgurl"
           placeholder="Background Image URL"
          ></b-form-input>
        </b-form-group>
       </b-form>
     </b-col>
    </b-row>
    
    <b-row>
      <b-col md="2">
         <b-form-file
           v-model="land.localFile" size="sm"
           placeholder="Select Image File"
           drop-placeholder="-"
           browse-text="-"
           :state="Boolean(land.localFile)">
         </b-form-file> 
      </b-col>
      <b-col md="2">
         <b-button size="sm"
          v-if="land.localFile"
          variant="primary"
          @click="do_upload_bgurl()">
          Upload
        </b-button>
      </b-col>
    </b-row>
    
    <b-row style="margin-top: 1rem">
      <b-col>
      <b-form @submit.prevent="">
        <b-form-group label="Schedule Header Text">
          <b-form-input
           type="text"
           v-model.trim="land.scmsg"
           placeholder="Schedule Table Header Text"
          ></b-form-input>
        </b-form-group>
       </b-form>
      </b-col>
    </b-row>
    
    <b-row style="margin-top: 1rem">
      <b-col>
        <b-form @submit.prevent="">      
           <b-form-group
             label="Schedule shows Webinars from these Rooms "
             :state="roomin_state"
             label-for="tags-validation">
             <b-form-tags
               input-id="tags-validation"
               :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
               v-model="land.rooms"
               :state="roomin_state"
               :tag-validator="roomValidator"
               placeholder="Add Room..."
               separator=" "
             ></b-form-tags>
             <template v-slot:invalid-feedback>
                Invalid Room Entry
             </template>
             <template v-slot:description>
               <div id="tags-validation-help">
                  What rooms to include in the public schedule?
               </div>
             </template>
           </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2">
        <b-button
          class=""
          variant="primary"
          @click="updateAdm"
          small>
           Save All
         </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vx_api from "../vuemix";
import { sync } from "vuex-pathify";

export default {
  name: "admacc",
  components: {},
  created() {
  },
  data() {
    return {
      land:{},
    };
  },
  computed: {
    roomin_state: function() {
       return true;
    },
  },
  methods: {
    handle_get_adm: function(msg) {
      let vue = this;
      if (!wss_ishash(msg)) { return; }
      if (msg.data.ld) {
        vue.land = msg.data.ld;
      }
    },
    get_adm: function() {
      window.wss_send(vx, "get_adm", {subd: window.vx.subd});
    },
    roomValidator: function(room) {
      let vue = this;
      if (vue.land.rooms.length >= 10) {
        return false;
      }
      if (room != room.toLowerCase()) { return false; }
      return true;
    },
    updateAdm: function() {
      // eslint-disable-next-line
      console.log("update");
      let vue = this;
      let adm = {acc:{}};
      adm.acc.ld = vue.land;
      window.wss_send(vx, "set_adm", {subd: window.vx.subd, adm:adm});
    },
    do_upload_bgurl: function() {
      let vue = this;
      if (vue.land.localFile) {
         let reader = new FileReader();
         reader.onload = function(e) {
           let img = e.target.result;
           vx_api.createMyTn(window.vx, {kind:"acc_bg"}).then(stream => {
             if (stream && stream.upload && stream.upload.url) {
                let url = stream.upload.url;
                vue.land.bgurl = "... uploading ..."
                api_put_awsfile(url,
                  {content_type:"image/png",
                   payload:img}, function(status,data) {
                     vue.land.bgurl = url.split("?")[0];
                     vue.land.localFile = null;
                   });
             }
           });
         }
         reader.onerror = function(e) {
           // eslint-disable-next-line
           console.log("file error");
         }
         reader.readAsText(vue.land.localFile);
      }
    },
    getLandingURL: function() {
      return "https://" + window.location.host + window.location.pathname+"#/land";
    },    
  },
  mounted() {
    let vue=this;
    window.wss_open(vx, {
      acc: vx.acc,
      uid: vx.user.id,
      routes_id: "adm",
      routes: {         
        auth_me: function(){
          vue.get_adm();
        },
        get_adm: vue.handle_get_adm,
      }
    });
  },
  beforeDestroy() {
    window.wss_clr_routes(window.vx,"adm");
  }
};
</script>
<style lang="scss">
.adm_main {
  margin: 10px;
}
</style>
